import { FC } from 'react';
import Chip from '../Chip';

type Props = {
  value: number;
};
const MatchingChip: FC<Props> = ({ value }) => {
  const percentageValue = Math.round(value * 100);
  if (percentageValue > 90) {
    return (
      <Chip bgColor="#ECFDF3" color="#027A48">
        {percentageValue}%
      </Chip>
    );
  }
  if (percentageValue > 80) {
    return (
      <Chip bgColor="#FFF1F3" color="#C01048">
        {percentageValue}%
      </Chip>
    );
  }
  if (percentageValue > 50) {
    return (
      <Chip bgColor="#FDF2FA" color="#C11574">
        {percentageValue}%
      </Chip>
    );
  }
  return (
    <Chip bgColor="#EFF8FF" color="#175CD3">
      {percentageValue}%
    </Chip>
  );
};

export default MatchingChip;
